exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".widget-sales__actions{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}", "", {"version":3,"sources":["/home/webuser/kmp3/releases/176/spa/src/components/widget-sales/WidgetSales.vue"],"names":[],"mappings":"AAEE,uBACE,4BAAA,6BAAA,0BAAA,qBAAA,CAAA","file":"WidgetSales.vue?vue&type=style&index=0&id=4fb0581e&prod&lang=scss","sourcesContent":["\n.widget-sales {\n  &__actions {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);

// exports
